import React from "react";
import { mapRogoDevSubTypeToDataTable as mapData } from "./Helper";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";
import GetRogoDebSubTypeColumns from "./ColumnDefinition/RogoDebSubTypeColumn/GetRogoDebSubTypeColumns";

const RogoDevSubTypeTable = ({
  data,
  handleOpenPopup,
  handleDelete,
  onDragEnd,
  status,
}) => {
  const columns = GetRogoDebSubTypeColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={500}
      onDragEnd={onDragEnd}
    />
  );
};

export default RogoDevSubTypeTable;
